import type { Components } from '@mui/material/styles';

export default function MUIMenuList(): Components['MuiMenuList'] {
  return {};
}
